module.exports = __webpack_public_path__ + "img/17.7b51e824.svg";